import { createActionGroup, emptyProps } from '@ngrx/store';

export const UtilitiesActions = createActionGroup({
  source: 'Utilities',
  events: {
    Progress: emptyProps,
    Complete: emptyProps,
  },
});
